import { css, cx } from 'emotion';
import {
	desktopMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
	headingLarge,
	headingXLarge,
	textBlock,
	cardSection,
	contentSection,
} from 'inside-out/global-styles';

export const titleStyle = cx(
	headingXLarge,
	css({
		marginBottom: '24px',
	})
);

export const textStyle = cx(
	textBlock,
	css({
		maxWidth: '800px',
		marginBottom: '15px',
	})
);

export const cardsWrapStyle = css({
	position: 'relative',

	'&:after': {
		position: 'absolute',
		top: '0',
		left: '0',
		borderRadius: '0 8px 8px 0',
		width: '80%',
		height: 'calc(100% - 25px)',
		background: '#f6f6f6',
		content: '" "',
		display: 'block',
	},
});

export const cardsSectionStyle = cx(
	cardSection(),
	css({
		position: 'relative',
		zIndex: '2',
		top: '-50px',
	})
);

export const contactWrapStyle = css({
	display: 'flex',
	flexDirection: 'row',
	flexWrap: 'wrap',
	alignItems: 'top',
	margin: '20px 0 40px 0',
});

export const contactColumnStyle = cx(
	contentSection('#fff'),
	css({
		width: '50%',
		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			width: '100%',
		},
	})
);

export const contactContentStyle = cx(
	textBlock,
	css({
		marginBottom: '39px',
		maxWidth: '355px',
	})
);

export const contactTitleStyle = cx(
	headingLarge,
	css({
		marginBottom: '24px',
	})
);

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',
});



// WEBPACK FOOTER //
// ./src/page-styles/get-involved/index.js